module.exports = __webpack_public_path__ + "static/media/check.55e8a392.svg";